import styles from './ManagedEntry.module.css';

/** Managed access failures must never expose native provider or account setup. */
export function ManagedUnavailable({ message, portalOrigin = 'https://design.intelliminds.ai' }: { message: string; portalOrigin?: string }) {
  return (
    <main className={styles.center}>
      <h1>Intelliminds Design</h1>
      <p role="alert">{message}</p>
      <a href={portalOrigin}>Return to websites</a>
    </main>
  );
}
